import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react';
import { i18n } from '../../../../shared/localization';
import { DashboardMenu } from '../../components';

const { moreDashboard } = i18n.navigation;

export const MoreDashboards = () => {
  return (
    <Popover
      trigger="hover"
      placement="bottom-start"
      closeOnBlur={false}
      isLazy
      lazyBehavior="unmount"
      data-testid="more-dashboards-menu"
    >
      <PopoverTrigger data-testid="more-dashboards-trigger">
        <Text data-testid="more-dashboards-label">{moreDashboard}</Text>
      </PopoverTrigger>
      <Portal data-testid="more-dashboards-portal">
        <PopoverContent data-testid="more-dashboards-popover-content">
          <DashboardMenu />
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
